import { AuthToken } from '@/app/shared/auth/auth-token'
import api from '@/app/shared/axios/api'

export default class AuthService {
  static async createToken(user) {
    AuthToken.set('')
    const response = await api.post('auth/token/login/', {
      email: user.email,
      password: user.password
    })
    return response.data
  }

  static async login(user) {
    const response = await api.post('auth/token/login/', {
      email: user.email,
      password: user.password
    })
    return response.data
  }
}
